<template>
    <v-card>
        <v-card-text v-if="demo">
            <v-btn color="primary" block :to="{ name: 'demos', params: { demo: demo.name } }">{{ demo.name }}</v-btn>
            <p>
                {{ demo.description }}
            </p>
        </v-card-text>
        <v-card-text v-else>
            Demo niet gevonden
        </v-card-text>
    </v-card>
</template>

<script>
import demos from '../../../demos'

export default {
    props: {
        message: {
            required: true,
        },
        context: {
            required: true,
        },
    },
    computed: {
        demoName () {
            if (!this.message.entities[0]) {
                return
            }
            return this.message.entities[0].option
        },
        demo () {
            if (!this.demoName) {
                return null
            }

            return demos.state.demos.find((demo) => {
                return demo.name === this.demoName
            })
        },
    },
}
</script>
